'use strict';
var theme = {
	init: function () {
		this.events();
		this.afterInit();
	},

	afterInit: function () {
		var self = this;
		this.initSlider('.main-slider');

		this.productBannerSlider('.banner-products .products-content');
		this.commentRate();
		this.mobileNavigation.init();

		$.each($('.featured-products'), function (i, item) {
			self.productSlider($(item).find('.products-content'));
		})

		this.product.init();
	},

	mobileNavigation: {
		init: function () {
			if (!window.matchMedia('(max-width: 991px)').matches) {
				return;
			}

			this.clone();
			this.events();
		},

		clone: function () {
			const header = document.querySelector("#header");
			const hamburgerContent = document.querySelector(".hamburger-content");


			/*if (header && hamburgerContent) {
				const headerBottom = header.getBoundingClientRect().bottom;
				const offsetAboveHeader = Math.abs(headerBottom);
				hamburgerContent.style.top = `${offsetAboveHeader}px`;
			}*/

			$.each($('nav[data-target-id]'), function() {
				var id = $(this).data('target-id');
				$('li.has-sub-category[data-navigation-id="'+ id +'"]').append($(this).clone());
			});
		},

		openSubCategories: function (element) {
			if (element.hasClass('selected')) {
				element.removeClass('selected');
			} else {
				element.addClass('selected');
			}
		},

		events: function() {
			var self = this;
			$(document).on('click', '.hamburger-content .has-sub-category a', function () {
				self.openSubCategories($(this).parent());
			});
		},
	},

	commentRate: function () {
		$('.prd-comment-rating').each(function () {
			$(this).rateYo({
				rating: $(this).attr('data-rank'),
				starWidth: "16px",
				normalFill: "#D3D3D3",
				ratedFill: "#FFD43D"
			});
		});
	},

	productSlider: function (element) {
		if ($(element).length == 0) {
			return;
		}
		$(element).slick({
			autoplay: true,
			autoplaySpeed: 4000,
			arrows: false,
			dots: true,
			infinite: false,
			speed: 300,
			slidesToShow: 5,
			slidesToScroll: 5,
			prevArrow: '<button type="button" class="slick-prev" aria-label="Previous"><i class="fas fa-angle-left"></i></button>',
			nextArrow: '<button type="button" class="slick-next" aria-label="Next"><i class="fas fa-angle-right"></i></button>',
			responsive: [
				{
					breakpoint: 1440,
					settings: {
						slidesToShow: 4,
						slidesToScroll: 4
					}
				},
				{
					breakpoint: 991,
					settings: {
						slidesToShow: 3,
						slidesToScroll: 3
					}
				},
				{
					breakpoint: 767,
					settings: {
						slidesToShow: 2,
						slidesToScroll: 2
					}
				},
				{
					breakpoint: 575,
					settings: {
						slidesToShow: 2,
						slidesToScroll: 2
					}
				}
			]
		});

		$(element).on('afterChange', function (event, slick, currentSlide) {
			if ((slick.$slides.length - slick.options.slidesToShow) <= currentSlide) {
				$(element).slick('slickGoTo', 0);
			}
		});
	},

	productBannerSlider: function (element) {
		if ($(element).length == 0) {
			return;
		}
		$(element).slick({
			autoplay: true,
			autoplaySpeed: 4000,
			arrows: false,
			dots: false,
			infinite: false,
			speed: 300,
			slidesToShow: 4,
			slidesToScroll: 1,
			variableWidth: false,
			prevArrow: '<button type="button" class="slick-prev" aria-label="Previous"><i class="fas fa-angle-left"></i></button>',
			nextArrow: '<button type="button" class="slick-next" aria-label="Next"><i class="fas fa-angle-right"></i></button>',
			responsive: [
				{
					breakpoint: 1440,
					settings: {
						slidesToShow: 3,
					}
				},
				{
					breakpoint: 767,
					settings: {
						slidesToShow: 2,
					}
				},
				{
					breakpoint: 575,
					settings: {
						slidesToShow: 2,
					}
				}
			]
		});

		$(element).on('afterChange', function (event, slick, currentSlide) {
			if ((slick.$slides.length - slick.options.slidesToShow) <= currentSlide) {
				$(element).slick('slickGoTo', 0);
			}
		});
	},

	initSlider: function (element) {
		if ($(element).length == 0) {
			return;
		}
		$(element).slick({
			autoplay: true,
			autoplaySpeed: 7000,
			arrows: false,
			dots: true,
			infinite: true,
			speed: 300,
			slidesToShow: 1,
			slidesToScroll: 1,
			fade: true,
			cssEase: 'ease-in-out',
			adaptiveHeight: true
		});
		$(element).on('afterChange', function (event, slick, currentSlide) {
			if ((slick.$slides.length - slick.options.slidesToShow) <= currentSlide) {
				$(element).slick('slickGoTo', 0);
			}
		});
	},

	product: {
		init: function() {
			this.productImageSlider();
		},
		
		productImageSlider: function() {
			$('.product-image-slider').slick({
				autoplay: true,
				autoplaySpeed: 4500,
				arrows: false,
				dots: true,
				infinite: false,
				speed: 300
			});
		},
	},

	events: function () {
		var _t = this;

		$(document).on('click', '[data-target="search-content"]', function() {
			setTimeout(() => {
				$('[data-selector="search-form"] input').focus()
			}, 200);
		});
	}
}

$(function () {
	theme.init();
	openbox.init();
});